import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { colors, s } from "../lib/theme";

export default function PublicActivities() {
  const [activities, setActivities] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = () => api.publicActivities().then(setActivities).catch((err) => setError(err.message));
    load();
    // Esta portada no tiene conexión en vivo (lista varias actividades a
    // la vez, no una sola) — se refresca sola cada 20s, para no depender
    // de que alguien recargue la página a mano para ver datos frescos.
    const interval = setInterval(load, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={s.page}>
      <h1 style={s.h1}>Actividades en directo</h1>
      <p style={s.subtitle}>Sigue en tiempo real qué estaciones están operando ahora mismo — sin necesidad de iniciar sesión.</p>

      {error && <div style={{ ...s.errorBox, marginTop: 16 }}>{error}</div>}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14, marginTop: 22 }}>
        {activities?.map((a) => (
          <div key={a.id} style={{ ...s.card, position: "relative", overflow: "hidden" }}>
            {a.finished ? (
              <span style={{
                position: "absolute", top: 14, right: -34, width: 140, textAlign: "center",
                background: "#7a2c2c", color: "#ffe3e3", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em",
                padding: "4px 0", transform: "rotate(45deg)", boxShadow: "0 1px 4px rgba(0,0,0,0.4)",
              }}>
                FINALIZADO
              </span>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: colors.green, display: "inline-block" }} />
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", color: colors.green }}>EN DIRECTO</span>
              </div>
            )}

            <Link to={`/directo/${a.id}`} style={{ textDecoration: "none", display: "block" }}>
              {a.logo_url && (
                <img src={a.logo_url} alt="" style={{ width: 56, height: 56, borderRadius: 8, objectFit: "cover", marginBottom: 10, marginTop: a.finished ? 12 : 0, border: `1px solid ${colors.lineStrong}` }} />
              )}
              <div style={{ fontSize: 18, fontWeight: 700, color: colors.text, marginBottom: 10 }}>{a.name}</div>
              {!a.finished && (
                <div style={{ fontSize: 12.5, color: colors.textDim }}>
                  {a.operators_live} operadores activos · {a.qso_count} QSO
                </div>
              )}
            </Link>
          </div>
        ))}
        {activities && activities.length === 0 && (
          <p style={{ color: colors.textFaint }}>No hay ninguna actividad en directo ahora mismo.</p>
        )}
      </div>
    </div>
  );
}
